module.exports = __webpack_public_path__ + "2a1e664f10ced05c2c12bfc449c8c5b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/create_workshop_info/top_background_mob@3x.jpg
// module id = 653
// module chunks = 0